import React, { useMemo, useState } from 'react'
import { Form, Button } from 'react-bootstrap'

export default function CategoryDetailsForm({ node, onAddSub, onRename, onDelete, disableSlugEdit = true, pending }) {
  const [name, setName] = useState('')
  const [newSubName, setNewSubName] = useState('')

  useMemo(() => {
    if (node) setName(node.name || '')
    else setName('')
    setNewSubName('')
    return true
  }, [node])

  if (!node) {
    return (
      <div>
        <p className='text-muted'>Select a category to view or edit details. You can also add a new root category from the left.</p>
      </div>
    )
  }

  return (
    <div>
      <Form>
        <Form.Group className='mb-3'>
          <Form.Label>Category ID</Form.Label>
          <Form.Control value={node._id} readOnly plaintext />
        </Form.Group>
        <Form.Group className='mb-3'>
          <Form.Label>Level</Form.Label>
          <Form.Control value={String(node.level ?? '')} readOnly plaintext />
        </Form.Group>
        <Form.Group className='mb-3'>
          <Form.Label>Parent</Form.Label>
          <Form.Control value={node.parent || '(root)'} readOnly plaintext />
        </Form.Group>
        <Form.Group className='mb-3'>
          <Form.Label>Slug</Form.Label>
          <Form.Control value={node.slug || ''} readOnly={disableSlugEdit} disabled={disableSlugEdit} onChange={() => {}} />
          {disableSlugEdit && <Form.Text className='text-muted'>Slug edits are disabled to avoid breaking product paths.</Form.Text>}
        </Form.Group>
        <Form.Group className='mb-3'>
          <Form.Label>Name</Form.Label>
          <Form.Control value={name} onChange={(e) => setName(e.target.value)} />
        </Form.Group>
        <div className='d-flex gap-2'>
          <Button variant='primary' disabled={pending || !name.trim()} onClick={() => onRename && onRename(name.trim())}>Rename</Button>
          <Button variant='danger' disabled={pending || !node.isLeaf} onClick={() => onDelete && onDelete()}>Delete</Button>
        </div>
      </Form>

      <hr />
      <h6>Add Subcategory</h6>
      <Form className='d-flex gap-2'>
        <Form.Control placeholder='Subcategory name' value={newSubName} onChange={(e) => setNewSubName(e.target.value)} />
        <Button variant='secondary' disabled={pending || !newSubName.trim()} onClick={() => onAddSub && onAddSub(newSubName.trim())}>Add</Button>
      </Form>
    </div>
  )
}
